import React, { useRef, useEffect } from 'react';
import './modal.css';

const MODAL = ({ isOpen, hasCloseBtn = true, onClose, children }) => {
  const modalRef = useRef(null);

  const handleCloseModal = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      handleCloseModal();
    }
  };

  useEffect(() => {
    const modalElement = modalRef.current;
    if (!modalElement) return;

    if (isOpen && !modalElement.open) {
      modalElement.showModal();
    } else if (!isOpen && modalElement.open) {
      modalElement.close();
    }
  }, [isOpen]);

  return (
    <dialog ref={modalRef} onKeyDown={handleKeyDown} onCancel={(event) => { event.preventDefault(); handleCloseModal(); }} className="modal" aria-label="Edit details">
      {hasCloseBtn && (
        <button className="modal-close-btn" onClick={handleCloseModal}>
          Close
        </button>
      )}
      {children}
    </dialog>
  );
};

export default MODAL;
